<template>
  <div class="mobile-home surface-ground">
    <div class="logo-area mt-10">
      <h1 class="text-4xl font-bold text-primary">통합IT자산관리 시스템</h1>
    </div>
    <div class="welcome-text">
      <p class="text-xl text-surface-700 dark:text-surface-0/80">환영합니다!<br>모바일 자산관리 서비스입니다.</p>
    </div>
    <div class="gap-4 justify-center px-4 mt-4">
      <!-- 벤더 사용자인 경우 벤더 대시보드 버튼 표시 -->
      <Button v-if="authStore.isVendorUser" label="벤더 대시보드" class="p-button flex-1 w-full mt-4" @click="goVendorDashboard" />
      <Button label="고장신고" class="p-button flex-1 w-full mt-4" @click="showReportDialog = true" />
      <!-- <Button label="자산조회" class="min-w-[300px] max-w-[650px] flex-wrap" @click="goAsset" /> -->
      <Button label="고장신고 처리현황" class="p-button flex-1 w-full mt-4" @click="goIssueReportList" />
      <Button label="자산 스캔(QR코드)" class="p-button flex-1 w-full mt-4" @click="showMobileAssetQrScan = true" />
      <Button label="자산 관리(Helpdesk)" class="p-button flex-1 w-full mt-4" @click="goAsset" v-if="isHelpdeskRole" />
    </div>
    <IssueReportDialog v-if="showReportDialog" @close="showReportDialog = false" />
    <AssetDialog v-if="showAssetDialog" :asset-number="selectedAssetNumber" @close="showAssetDialog = false" />
    <MobileAssetQrScan :visible="showMobileAssetQrScan" @asset="handleAsset" @close="showMobileAssetQrScan = false" />
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import IssueReportDialog from '@/components/IssueReportDialog.vue';
// import AssetDialog from '@/views/asset/Asset.vue';
import MobileAssetQrScan from './asset/MobileAssetQrScan.vue';
import {useAuthStore} from "@/stores/auth";

const router = useRouter();
const showReportDialog = ref(false);
const showAssetDialog = ref(false);
const showMobileAssetQrScan = ref(false);
const selectedAssetNumber = ref('');

const authStore = useAuthStore();
const isHelpdeskRole = authStore.hasRole('HELPDESK') | authStore.hasRole('ASSET_PC');

function goAsset() {
  router.push('/asset/AssetManagement');
}

function goIssueReportList() {
  router.push('/issue/IssueReportList');
}

function goVendorDashboard() {
  router.push('/vendor/dashboard');
}

function handleAsset(assetNumber) {
  selectedAssetNumber.value = assetNumber;
  router.push({
    name: 'AssetManagement',
    query: { assetNumber: assetNumber }
  });
}
</script>

<style scoped>

.logo-area {
  margin-bottom: 2rem;
  text-align: center;
}

.welcome-text {
  margin-bottom: 2.5rem;
  text-align: center;
}

@media (max-width: 480px) {
  .logo-area h1 {
    font-size: 1.8rem;
  }
  
  .welcome-text p {
    font-size: 1.1rem;
  }
}
</style> 